module.exports = __webpack_public_path__ + "static/media/patient_control@2x.c4c51a3a.png";